import { html, nothing } from 'lit';
import service from '@mfe/service';
import { TRACKER_EVENT_NAME_CANCEL_CHANGE_PERMISSION } from '@mfe/service/tracker';
import store from '@mfe/store';
import { save, cancelPage } from '@mfe/store/consents';
import { ConsentGroup } from '@mfe/types/common';
import type Tefcoms from '../../tef-coms';

export const cancelButton = html`
<one-button
  variant="plain"
  @click=${
  /* eslint-disable indent */
  () => {
    store.dispatch(cancelPage());
    service.tracker.doTracking(
      TRACKER_EVENT_NAME_CANCEL_CHANGE_PERMISSION,
      {},
    );
  }
}
> Abbrechen
</one-button>`;

export const saveButton = (changesMadePage: boolean) => html`
<one-button
    .disabled=${!changesMadePage}
    @click=${
  () => {
    store.dispatch(save());
  }
  /* eslint-enable indent */
}
> Speichern
</one-button>`;

/* eslint-disable @typescript-eslint/no-unsafe-member-access */
export const consentGroupTemplate = (consentGroup: ConsentGroup, idx: number, tefComs: Tefcoms) => html`

          <tef-coms-consent-group
              .consentGroup=${consentGroup}
              .groupIndex=${idx}
              .mode=${tefComs.mode}
          >
          </tef-coms-consent-group>
        `;

export const buttonModeTemplate = (buttonModeButton: string, changesMadePage: boolean) => {
  const buttonActive = changesMadePage || buttonModeButton === 'saveActive';
  const showButton = !buttonModeButton || buttonModeButton.startsWith('save'); // save && saveActive

  return html`
    <one-button-group>
      ${showButton ? saveButton(buttonActive) : nothing}
      <one-spacer size="fill"></one-spacer>
      ${!buttonModeButton ? cancelButton : nothing}
    </one-button-group>`;
};
